import { CommonModule } from '@angular/common'
import { Component, input } from '@angular/core'
import { FooterBasicComponent } from './basic/footer-basic.component'
import { IComponentConfig } from 'src/app/core/interfaces/config.interface'

@Component({
  selector: 'app-footer',
  template: `
    @switch (config().template) {
      @case('basic') {
        <ng-container *ngTemplateOutlet="basic"></ng-container>
      }
      @default {
        <ng-container *ngTemplateOutlet="basic"></ng-container>
      }
    }

    <ng-template #basic>
      <app-footer-basic
          [styles]="config().data.styles"
          [address]="config().data.address"
          [address_line_2]="config().data.address_line_2"
          [phone]="config().data.phone"
          [email]="config().data.email"
          [facebook]="config().data.facebook"
          [twitter]="config().data.twitter"
          [instagram]="config().data.instagram"
          [youtube]="config().data.youtube"
          [linkedin]="config().data.linkedin"
          [copyright_text]="config().data.copyright_text"
          [link_1_text]="config().data.link_1_text"
          [link_1_url]="config().data.link_1_url"
          [link_2_text]="config().data.link_2_text"
          [link_2_url]="config().data.link_2_url"
          [link_3_text]="config().data.link_3_text"
          [link_3_url]="config().data.link_3_url"
        />
    </ng-template>
  `,
  imports: [
    CommonModule,
    FooterBasicComponent,
  ],
})
export class FooterComponent {
  config = input.required<IComponentConfig>()
}
